import Crud from '../views/EstablishmentType/Crud'
import Entity from '../views/EstablishmentType/Add'

let routes = {
    path: '/establishment_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/establishment_types/add',
            name: 'NewEstablishmentType',
            component: Entity,
            meta: {
                pageTitle: 'establishmentType.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'establishmentType.form.newTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/establishment_types/edit/:id?',
            name: 'EditEstablishmentType',
            component: Entity,
            meta: {
                pageTitle: 'establishmentType.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'establishmentType.form.editTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/establishment_types',
            name: 'list-establishment-types',
            component: Crud,
            meta: {
                pageTitle: 'establishmentType.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'establishmentType.crud.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
